import { Main } from "../components/answered-application/Main";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

const AnsweredApplicationRegistration = () => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.APPLY_MERCHANT_DIRECT);

  return <Main />;
};

export default AnsweredApplicationRegistration;
